export const BrandMark = ({ size = 40 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none" aria-hidden="true">
    <rect x="1.5" y="1.5" width="45" height="45" rx="12" fill="#111F30" stroke="rgba(255,255,255,0.14)" />
    <rect x="12" y="21" width="3.2" height="6" rx="1.6" fill="#2FD36A" opacity="0.55" />
    <rect x="16.6" y="17" width="3.2" height="14" rx="1.6" fill="#2FD36A" opacity="0.8" />
    <path d="M22 16.5 L34 24 L22 31.5 Z" fill="#2FD36A" />
  </svg>
);

export const Brand = ({ size = 34, className = "" }) => (
  <span className={`inline-flex items-center gap-2.5 ${className}`}>
    <BrandMark size={size} />
    <span className="font-display font-extrabold tracking-tight text-lg leading-none">
      <span className="text-[#0E1E2E]">UMG</span> <span className="text-brand">MEDIA</span>
    </span>
  </span>
);
